module.exports = __webpack_public_path__ + "img/icon_map_1_hg.d4e10548.png";